import { lazy } from 'react';

export const PlatformPageAsync = lazy(async () => import('./PlatformPage'));
